/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-22
 *
 * bestgob-client - processes.api.js
 **/

import {httpClientBackend} from "./http-client";

/**
 * Obtiene una lista de Procesos filtrados por categorias
 * @param request
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
const getByCategory = (request) => httpClientBackend.get('get_process', {params: request})

/**
 * Obtiene el lstado de ctaegorias por el cual estan divididos los procesos
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
const getCategories = () => httpClientBackend.get('get_categories')

/**
 * Muestra los requerimientos del proceso antes de iniciar un nuevo
 *
 * @param id
 * @param invited
 * @param sessionUser
 * @returns {Promise<AxiosResponse<any>>}
 */
const getProcessRequirements = (id, invited, userId, sessionUser) =>
    httpClientBackend.get(`section_by_process/${id}/${invited}/${userId}/${sessionUser}`)

/**
 * Obtiene los detalles de un proceso, conuyendo el listado de tareas que contiene programado
 * @param id identificador del proceso
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
const getDetailsAndTasks = (id) =>
    httpClientBackend.get(`procesos/${id}/tareas`)

export {getByCategory, getCategories, getProcessRequirements, getDetailsAndTasks}